module.exports = __webpack_public_path__ + "static/media/Seta_aberta.cf1597ef.svg";